<template>
  <div class="text-center">
    <v-dialog v-model="DialogDetails" persistent width="500">
      <v-card>
        <v-card-title> {{ categoryDetails.categoryname }} </v-card-title>
        <v-card-actions>
          <v-btn color="orange lighten-2" text>
            Category Names Translate
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="show = !show">
            <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </v-card-actions>
        <v-expand-transition>
          <div v-show="show">
            <v-divider></v-divider>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr
                      v-for="item in categoryDetails.translate
                        .categorynametrans"
                      :key="item.name"
                    >
                      <td>{{ item }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </div>
        </v-expand-transition>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDetail"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ["DialogDetails", "categoryDetails"],
  data() {
    return {
      show: true,
    };
  },
  methods: {
    closeDetail() {
      this.$emit("DialogDetailsClose");
    },
  },
};
</script>
